export {
  axisTop,
  axisRight,
  axisBottom,
  axisLeft
} from "./axis";



//////////////////
// WEBPACK FOOTER
// ./~/d3-axis/src/index.js
// module id = ./node_modules/d3-axis/src/index.js
// module chunks = 53